import { VerticaisManager } from "src/components/vendas/VerticaisManager";
import { GeradorItem, ListagemItem, Projeto } from "../types";
import api from 'src/framework/providers/api'
import { IDataResponse } from "src/framework/providers/api";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { exibeJustificativaValorServico$ } from "src/store/vendas/projetos/store";
import { ID_INVERSOR, ID_MICROINVERSOR, ID_MODULO } from "src/components/componentes/types";
import { TIPO_FATURAMENTO } from "../constants";

export interface EstruturasGruposSalvar {
  quantidade: number;
  componente_id: number;
  estruturas_grupo_id: number;
  "@remove"?: boolean;
}

export interface ComponentesSalvar {
  componente_id: number;
  categoria_componentes_id: number;
  quantidade: number;
  valor_unitario: number;
  estruturas_grupos?: EstruturasGruposSalvar[];
  "@remove"?: boolean;
}

function formatarComponentesSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []
  for (const item of items) {
    comps.push({
      componente_id: Number(item.componente_id),
      categoria_componentes_id: Number(item.categoria_componentes_id),
      quantidade: Number(item.quantidade),
      valor_unitario: Number(item.valor),
  })   
  }
  return comps;
}

function converterParaKw(valor?: number): number {
  return (valor || 0) / 1000;
}

function formatarEstruturasSalvar(items: ListagemItem[]): ComponentesSalvar[] {
  const comps: ComponentesSalvar[] = []

  for (const item of items) {
    const alreadyAddedIndex = comps.findIndex(comp => comp.componente_id === item.componente_id)

    if (alreadyAddedIndex !== -1) {
      comps[alreadyAddedIndex].quantidade = comps[alreadyAddedIndex].quantidade + Number(item.quantidade)

      if (Array.isArray(comps[alreadyAddedIndex].estruturas_grupos)) {
        comps[alreadyAddedIndex].estruturas_grupos?.push({
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        })
        comps[alreadyAddedIndex]["@remove"] = comps[alreadyAddedIndex].estruturas_grupos?.every(item => item["@remove"] === true) ? true : undefined
      } else {
        comps[alreadyAddedIndex].estruturas_grupos = [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
        comps[alreadyAddedIndex]["@remove"] = item["@remove"] || undefined
      }
    } else {
      comps.push({
        componente_id: Number(item.componente_id),
        categoria_componentes_id: Number(item.categoria_componentes_id),
        quantidade: Number(item.quantidade),
        valor_unitario: Number(item.valor),
        "@remove": item["@remove"] || undefined,
        estruturas_grupos: [{
          "@remove": item["@remove"] || undefined,
          componente_id: Number(item.componente_id),
          estruturas_grupo_id: Number(item.estruturas_grupo_id),
          quantidade: Number(item.quantidade),
        }]
      })
    }
  }

  return comps
}

const formatSolucaoSugeridaPersonalizado = (data: Projeto) => {
  return {
    tipo_inversor: data.tipo_inversor?.value,
  }
}

const formatSolucaoSugeridaPersonalizadoOff = (data: Projeto) => {
  return {
    tipo_solucao: data.tipo_solucao?.value,
  }
}

const formatSolucaoSugeridaKit = (data: Projeto) => {
  return {
    tipo_inversor: data.tipo_inversor?.value,
  }
}

const formatSolucaoSugerida = (data: Projeto) => {
  if (data.tipo !== 'dimensionado') return []

  const componentes: typeof data.sugestoes.inversores = []

  if (!!data.sugestoes.inversores?.length) {
    componentes.push(...data.sugestoes.inversores.map(item => {
      return {
        id: item.id,
        quantidade: item.quantidade,
        categoria_componentes_id: item.categoria_componentes_id,
      }
    }))
  }

  if (!!data.sugestoes.modulo) {
    componentes.push({
      id: data.sugestoes.modulo.id,
      quantidade: data.sugestoes.modulo.quantidade,
      categoria_componentes_id: data.sugestoes.modulo.categoria_componentes_id,
    })
  }

  const acessoriosSugeridos = data.acessoriosSugeridos?.length ? data.acessoriosSugeridos : data.sugestoes.acessorios
  if (!!acessoriosSugeridos?.length) {
    componentes.push(...acessoriosSugeridos.map(item => ({
      id: item.id,
      quantidade: item.quantidade,
      categoria_componentes_id: item.categoria_componentes_id,
    })))
  }

  if(!!data.sugestoes?.estrutura?.length){
    componentes.push(...data.sugestoes.estrutura.map(item => ({
      id: item.id,
      quantidade: item.quantidade,
      categoria_componentes_id: item.categoria_componentes_id,
    })))
  }

  const fileiras = data.fileiras?.map(item => ({
    posicao: item.posicao_modulo?.value,
    estrutura_id: item.tipo_estrutura?.value,
    estruturas_grupo_id: item.tipo_estrutura?.estruturas_grupo_id,
    modulos_sequencia: item.quantidade_modulos,
    fileiras_iguais: item.fileiras,
  }))

  return {
    componentes,
    fileiras,
    potencia: data.potencia_desejada,
    inversor: data.tipo_inversor?.value,
    regiao_id: data.regioes.map(item => item.id),
    inversor_tensao: data.tensao_rede?.value,
    inversor_tipo_conexao: data.numero_fases?.value,
    consumo: data.modo_calculo === 'consumo' ? data.consumo_meses.map(item =>({ dia: item.day, consumo: item.value })) : [],
    tipo_projeto: data.tipo_projeto?.value,
    fator_perdas: Number(data.fator_perdas || 0),
    tipo_inversor: data.tipo_inversor?.value,
    inversor_modelo: data.inversor_modelo?.value,
  }
}


function getEstruturasPersonalizado(data: Projeto): ListagemItem[] {
  const estruturas: ListagemItem[] = []
    const selected = data.isEdit ? (data.estruturasSelecionadas || []) : data.estruturasSelecionadas?.filter(item => {
      const total = item.items.reduce((acc, curr) => acc + curr.quantidade, 0)
      if (total > 0) return true;
      return false;
    }) || []
    selected.forEach(grupo => {
      grupo.items.forEach(item => {
        if (data.isEdit) {
          if (item.quantidade === 0) {
            const oldItems = data.old_componentes_edicao || []

            if (oldItems.length) {
              const oldItem = oldItems.find(old => old.id === item.componente_id && item.estruturas_grupo_id === old.estruturas_grupo_id)

              if (oldItem) {
                estruturas.push({...item, "@remove": true})
              }
            }
          } else {
            estruturas.push(item)
          }
        } else {
          estruturas.push(item)
        }
      })
    })
    return estruturas;
}

function getEstruturasDimensionado(data: Projeto): ListagemItem[] {
  if (!data.isEdit) return data.estrutura_calculadas?.filter(item => Number(item.quantidade || 0) > 0) || []
  const estruturas: ListagemItem[] = []
  data.estrutura_calculadas.forEach(item => {
    if (item.quantidade === 0) {
      const oldItems = data.old_componentes_edicao || []

      if (oldItems.length) {
        const oldItem = oldItems.find(old => old.id === item.componente_id && item.estruturas_grupo_id === old.estruturas_grupo_id)

        if (oldItem) {
          estruturas.push({...item, "@remove": true})
        }
      }
    } else {
      estruturas.push(item)
    }
  })
  return estruturas;
}

function resolveEstruturas(data: Projeto) {
  const estruturasByTipo: {[index: string]: ListagemItem[]} = {
    'personalizado': getEstruturasPersonalizado(data),
    'dimensionado': getEstruturasDimensionado(data),
  }
  return estruturasByTipo[data.tipo || ''] || []
}


function formatarComponentes(data: Projeto): ComponentesSalvar[] {
  const componentes = []

  if (data.tipo === 'kit') return [];

  const moduloSelecionado = data.modulosList?.find(item => item.selecionado)
  const inversoresAdicionados = data.inversoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
  const acessoriosAdicionados = data.acessorios?.filter(item => Number(item.quantidade || 0) > 0) || []
  const controladoresAdicionados = data.controladoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
  const carregadoresAdicionados = data.carregadoresList?.filter(item => Number(item.quantidade || 0) > 0) || []
  const estruturasAdicionadas = resolveEstruturas(data)

  if (moduloSelecionado) {
    componentes.push(...formatarComponentesSalvar([moduloSelecionado]))
  }

  if (inversoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(inversoresAdicionados))
  }

  if (estruturasAdicionadas.length) {
    componentes.push(...formatarEstruturasSalvar(estruturasAdicionadas))
  }
  
  if (acessoriosAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(acessoriosAdicionados))
  }

  if (controladoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(controladoresAdicionados))
  }

  if (carregadoresAdicionados.length) {
    componentes.push(...formatarComponentesSalvar(carregadoresAdicionados))
  }

  if (!data.isEdit) {
    return componentes?.filter(i => (i?.quantidade > 0 && !i["@remove"]));
  }

  return componentes
}

function montarDisposicoes(disposicoes: any[]): { disposicoes: any[]; nomes: string[] }{
  if (!disposicoes?.length) return { disposicoes: [], nomes: [] }

  const items: { grupo_estrutura_id: number }[] = [];
  const nomeItems: string[] = [];


  for (let d of disposicoes) {
    nomeItems.push(d.nome);
      items.push({
          grupo_estrutura_id: d.id
      })
  }

  return { disposicoes: items, nomes: nomeItems }
}

function buscarPotenciaModulosKits(data: Projeto){
  if (data.tipo !== 'kit') return 0
  const items: GeradorItem[] = []
  data.geradores_kits.forEach(item => items.push(...item.items))
  const modulos = items.filter(item => item.categoria_componentes_id === ID_MODULO)
  return modulos.reduce((acc, curr) => acc + (curr.quantidade * curr.potencia), 0)
}

function buscarPotenciaInversoresKits(data: Projeto){
  if (data.tipo !== 'kit') return 0
  const items: GeradorItem[] = []
  data.geradores_kits.forEach(item => items.push(...item.items))
  const inversores = items.filter(item => (item.categoria_componentes_id === ID_INVERSOR) || (item.categoria_componentes_id === ID_MICROINVERSOR))
  return inversores.reduce((acc, curr) => acc + (curr.quantidade * curr.potencia), 0)
}

export async function salvarProjeto(manager: VerticaisManager, id: string | number | undefined, data: Projeto, usuario?: ExtraInfoUsuario, clonarProjeto?: boolean, hibrido?: boolean): Promise<IDataResponse>  {
  const moduloSelecionado = data.modulosList?.find(item => item.selecionado) || null
  const potenciaInversoresEmWatts = data.inversoresList?.filter(item => item.quantidade > 0).reduce((acc, curr) => acc + (curr.potencia * curr.quantidade), 0)
  const potenciaModulosEmWatts = moduloSelecionado ? (moduloSelecionado.quantidade * moduloSelecionado.potencia) : 0
  let valorTotalAvulsos = 0;

  if(data.tipo === "avulso" && data.avulsos){
    valorTotalAvulsos = data?.avulsos?.reduce((total: any, produto: any) => {
      return total + (produto?.valor * produto?.quantidade);
    }, 0);
  }

  const potenciaModulosKits = buscarPotenciaModulosKits(data)
  const potenciaInversoresKits = buscarPotenciaInversoresKits(data)

  const componentes = formatarComponentes(data)

  const projetosProvider = new ProjetosProvider();
  const recalcularValor = projetosProvider.confereRecalcular(componentes, data);

  const getValorServico = () => {
    if (!data.revenda_id) return 0;
    if (!data.recebe_servico) return 0
    if (data.revenda && !data.revenda?.segmentos_servico?.includes(data?.segmento?.includes("on") ? "on" : "off") && Number(data.valor_servico || 0) > 0) return 0;
    return data.valor_servico ? Number(data.valor_servico || 0) : 0
  }

  const getJustificativa = () => {
    const exibe = exibeJustificativaValorServico$.getValue();
    if (exibe === undefined) return data.justificativa_valor_servico || null
    return exibe && data.justificativa_valor_servico ? data.justificativa_valor_servico : null
  }

  const payload: any = {
    editar_projeto: data.isEdit,
    assistente_id: data.assistente_id,
    analista_id: data.analista_id,
    auto_comissao: data.auto_comissao,
    cidade_id: data.cidade?.id,
    cliente_proposta: data.cliente_proposta,
    codigo_venda: data.codigo_venda,
    cpf_cnpj_proposta: data.cpf_cnpj_proposta?.replace(/[^a-zA-Z0-9]/g,''),
    distribuidor_id: data.distribuidor_id,
    email_proposta: data.email_proposta,
    telefone_proposta: data.telefone_proposta,
    endereco: {
      bairro: data.bairro,
      cep: data.cep?.replace(/[^\d]/g, ''),
      logradouro: data.endereco_proposta,
      numero: data.numero,
      cidade_id: data.cidade?.id,
      estado_id: data.estado?.id,
    },
    estado_id: data.estado?.id,
    ev_id: data.ev?.id || data.ev_id,
    nota_fiscal_triangular: data.nota_fiscal_triangular,
    observacao: data.observacao,
    prioridade: data.prioridade,
    revenda_id: data.revenda?.id || data.revenda_id || null,
    segmento: data.segmento,
    setor: data.setor,
    situacao: data.situacao,
    supervisor_id: data.supervisor_id,
    tipo: data.tipo,
    titulo: data.titulo,
    servico: getValorServico() > 0 ? 'revenda' : null,
    valor_servico: getValorServico(),
    simultaneidade: Number(data.simultaneidade || 0),
    preco_kwh: Number(data.preco_kwh_com_imposto || 0),
    latitude: data.latitude || null,
    longitude: data.longitude || null,
    valor_servico_pis_cofins: data.revenda_id && getValorServico() > 0 ? data.valor_servico_pis_cofins : 0,
    vendedor_interno_id: data.vendedor_interno?.value || undefined,
    texto_termo_aceito: data.texto_termo_aceito || undefined,
    lista_termo_simulacao_financiamento: data.lista_termo_simulacao_financiamento || undefined,
    reativar: data.reativar,
    peso_gerador: data.resultado_calculos?.componentes?.peso_gerador,
    peso_telhado: data.resultado_calculos?.componentes?.peso_telhado,
    valor_anual_manutencao: data.valor_anual_manutencao,
    processo_v2: false,
    justificativa_valor_servico: getJustificativa(),
    sugestao_instalacao: data?.sugestao_instalacao || undefined,
  }

  if(hibrido){
    payload.hibrido = true;
  }
  
  if (data.tipo === 'vertical') {
    const disposicoes = montarDisposicoes(data.disposicoes as any[])

    Object.assign(payload, {
      engenharia: true,
      potencia: data.potencia,
      anexos: data.anexos,
      servico: data.servico || null,
      valor_servico: data.servico === 'revenda' ? getValorServico() : 0,
      valor_servico_pis_cofins: data.servico === 'revenda' && getValorServico() > 0 ? data.valor_servico_pis_cofins : 0,
      disposicoes: disposicoes.disposicoes,
      solicitacao: {
        ...data.solicitacao,
        grupos_estruturas: disposicoes.nomes.join(',')
      }
    })
  }

  if (data.tipo === 'dimensionado') {
    Object.assign(payload, {
      solucao_sugerida: formatSolucaoSugerida(data),
      valor_margem_produtos: 0,
      dados_finalizar: data?.dados_finalizar,
      tarifa_concessionaria_id: data?.tarifa_concessionaria_id,
      dados_concessionaria_payback: data?.dados_concessionaria_payback,
    })
  }

  if (data.tipo === 'personalizado' && data.segmento?.includes('on')) {
    Object.assign(payload, {
      solucao_sugerida: formatSolucaoSugeridaPersonalizado(data),
    })
  }

  if (data.tipo === 'personalizado' && data.segmento?.includes('off')) {
    Object.assign(payload, {
      solucao_sugerida: formatSolucaoSugeridaPersonalizadoOff(data),
    })
  }

  if (data.tipo === 'kit') {
    Object.assign(payload, {
      solucao_sugerida: formatSolucaoSugeridaKit(data),
    })
  }

  if (data.tipo === 'personalizado' || data.tipo === 'dimensionado' || data.tipo === 'kit') {
    Object.assign(payload, {
      componentes,
      tipo_faturamento: data.tipo_faturamento || TIPO_FATURAMENTO[0].value || null,
      potencia: potenciaModulosEmWatts ? DecimalUtil.toFixed(converterParaKw(potenciaModulosEmWatts), 2) : 0,
      potencia_inversor: converterParaKw(potenciaInversoresEmWatts),
    })
  }
  
  if (data.tipo !== 'vertical') {
    Object.assign(payload, {
      simulacao_financiamento: data.simulacao_financiamento || null,
      tempo_garantia_servico: data.tempo_garantia_servico,
      tempo_garantia_servico_unidade: data.tempo_garantia_servico_unidade?.value || null,
      valor: data.resultado_calculos?.componentes?.valor || 0,
      valor_projeto: Number(data.resultado_calculos?.componentes?.valor || 0) + Number(data.resultado_calculos?.servicos?.valor_com_pis_cofins || 0),
    })
  }

  if(data.tipo === 'kit') {
    Object.assign(payload, {
      carrinho_id: data.carrinho_id || undefined,
      potencia: potenciaModulosKits ? DecimalUtil.toFixed(converterParaKw(potenciaModulosKits), 2) : 0,
      potencia_inversor: converterParaKw(potenciaInversoresKits),
      percentual_comissao_distribuidor: data.percentual_comissao_distribuidor ? Number(data.percentual_comissao_distribuidor) : undefined,
      dados_termo: data.dados_termo,
    })
  }

  if(data.tipo === "avulso"){
    Object.assign(payload, {
      carrinho_id: data.carrinho_id || undefined,
      avulsos: data.avulsos,
      estado: data.estado ? data.estado : undefined,
      valor: valorTotalAvulsos,
      valor_projeto: valorTotalAvulsos,
      dados_termo: data.dados_termo,
    })
  }

  let primaryKey = id || undefined;
  if (primaryKey && recalcularValor) {
    primaryKey += "?recalcular=true";

    // Atualizar proposta quando for um updade
    Object.assign(payload, { atualizar_proposta: true })
  }

  if (primaryKey && usuario?.isIntelbras) {
    Object.assign(payload, {
      editado_admin: true,
    })
  }

  // remove tag de processo_v2 quando for um updade
  if(primaryKey){
    delete payload?.processo_v2;

    if(recalcularValor){
      primaryKey += "&atualizar_tarifas=true&atualizar_comissoes=true";
    }else{
      primaryKey += "?atualizar_tarifas=true&atualizar_comissoes=true";
    }
  }

  if (clonarProjeto) {
    primaryKey = undefined
 
    // Remover campos que não devem ser clonados
    delete payload.assistente_id
    delete payload.analista_id
    delete payload.atualizar_proposta
    delete payload.editado_admin
    delete payload.ev_id
    delete payload.supervisor_id
    delete payload.situacao
    
    return api.post({
      url: "/projetos/clonagem",
      data: {
        ...payload,
        projeto_original_id: id,
        clonar_via_payload: true
      }
    })
  }

  let result = await manager.save({
    row: payload,
    primaryKey: primaryKey
  })

  if (!primaryKey && result.statusCode === 400 && result.data?.[0]?.message.includes("Projeto") && result.data?.[0]?.message.includes("unique")) {
    result = await manager.save({
      row: payload,
      primaryKey: primaryKey
    })
  }

  return result
}